module.exports = __webpack_public_path__ + "img/rx.55d01d15.svg";